import { Moment } from "moment";
import { apiGet, API_URI } from "./index";

const subfolders = {
    getAllAsTreeview: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: number[]) => {
        const data = apiGet(`${API_URI}/api/subfolder/getall/treeview?projectId=${projectId}&startDate=${startDate.format("DD MMM YYYY HH:mm")}&endDate=${endDate.format("DD MMM YYYY HH:mm")}&streamIds=${streamIds.join(",")}`);
        return data;
    },
    getAllAsTreeviewBinType: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: number[]) => {
        const data = apiGet(`${API_URI}/api/subfolder/getall/treeview/bintype?projectId=${projectId}&startDate=${startDate.format("DD MMM YYYY HH:mm")}&endDate=${endDate.format("DD MMM YYYY HH:mm")}&streamIds=${streamIds.join(",")}`);
        return data;
    },
};

export default subfolders;
